
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 189","d":"M51.41 45.18a9.39 9.39 0 00-6.32 2.47l-23-13.32a8.76 8.76 0 000-4.49l22.74-13.19a9.58 9.58 0 10-3.1-7 10.05 10.05 0 00.27 2.22L19.28 25.06a9.62 9.62 0 100 14.05l23 13.34a8.61 8.61 0 00-.28 2.09 9.42 9.42 0 109.46-9.37z"}})])
          )
        }
      }
    